/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestRunnerState } from './AutoTestRunnerState';
const AutoTestRunnerParser = /* #__PURE__ */ parsers.object([
    ['state', AutoTestRunnerState],
]);
export class AutoTestRunner extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestRunnerParser.decode(input).map(res => new AutoTestRunner(res));
    }
    static unsafeDecode(input) {
        return AutoTestRunner.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestRunnerParser.encode(data);
    }
    static schema() {
        return AutoTestRunnerParser.schema();
    }
}
